import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkantElementsModule } from '@markant/elements-angular';

@Component({
  standalone: true,
  imports: [CommonModule, MarkantElementsModule],
  selector: 'markant-platform-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss'],
})
export class VideoPlayerComponent implements OnInit {
  @ViewChild('videoPlayer', { static: true }) videoPlayer!: ElementRef<HTMLVideoElement>;
  @ViewChild('videoPlayerWrapper', { static: true }) videoPlayerWrapper!: ElementRef<HTMLDivElement>;

  isPlaying = false;
  calculatedHeightString = '';
  pauseHeightString = '';
  private _videoSrc = '';

  @Input() height = 250;
  @Input() autoResize = true;
  @Input() isShownAsHero = false;

  @Input() set videoSrc(videoSrc: string) {
    this._videoSrc = videoSrc;
  }

  get videoSrc(): string {
    return this._videoSrc;
  }

  private resizeTimer!: ReturnType<typeof setTimeout>;

  @HostListener('window:resize')
  onResize(): void {
    if (this.autoResize) {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.setHeightStrings(), 300);
    }
  }

  ngOnInit(): void {
    this.setHeightStrings();
  }

  toggleVideoPlay(event: MouseEvent): void {
    event.stopPropagation();
    this.videoPlayer.nativeElement.play();
    this.isPlaying = true;
  }

  setHeightStrings(): void {
    const calculatedHeight = this.calculateHeight();

    this.calculatedHeightString = this.getHeightString(calculatedHeight);
    this.pauseHeightString = this.getHeightString(calculatedHeight * (1 + 1 / 1.3));
  }

  private calculateHeight(): number {
    if (this.isShownAsHero) {
      const viewportHeight = window.innerHeight;
      return viewportHeight / 1.5;
    }

    const videoPlayerWrapperWidth = this.videoPlayerWrapper?.nativeElement?.offsetWidth ?? 0;

    if (videoPlayerWrapperWidth > 0) {
      return videoPlayerWrapperWidth / 2.3;
    } else {
      return 0;
    }
  }

  private getHeightString(height: number): string {
    return `${Math.round(Math.max(0, height))}px`;
  }
}
